module.exports = __webpack_public_path__ + "static/media/ph.a5423685.svg";